// extracted by mini-css-extract-plugin
export default {"zoomModal":"E1-z","image":"F1-z","button":"G1-z","isOverlayShown":"H1-z"};